import React, { useContext } from "react"
import Context from "../utils/Context"
import ShowMessage from "../components/ShowMessage"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog } from '@fortawesome/free-solid-svg-icons'
import api from "../api/api"

export default function ModalSendMission({ missionName, setActiveModalSendMission }) {
    const context = useContext(Context)

    const closeModal = () => {
        setActiveModalSendMission(false)
    }

    const sendMission = async (dropName) => {
        try {
            const payload1 = {
                device: missionName,
                processed: false,
                uname: context.username,
                signature: context.signatureCounter,
                dtInsert: new Date(),
            }
    
            const payload2 = {
                device: dropName,
                processed: false,
                uname: context.username,
                signature: context.signatureCounter,
                dtInsert: new Date(),
            }
    
            await api.sendTrigger(payload1)
            await api.sendTrigger(payload2)
    
            context.actions.setMessage({ message: "Started.", type: "success" })
            closeModal()
        } catch (error) {
            context.actions.setMessage({ message: "Erro.", type: "error" })
            context.actions.setErrorMessage(error.response?.status)
        }
    }

    return (
        <div className="modal is-active">
            <div className="modal-background"></div>

            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                <header className="modal-card-head">
                    <p className="modal-card-title">Send Mission to Robot</p>

                    <button
                        className="delete"
                        aria-label="close"
                        onClick={closeModal}
                    ></button>
                </header>

                <section className="modal-card-body">
                    <p className="subtitle">Mission from: {missionName}</p>

                    <p className="subtitle">To:</p>
                    
                    {context.availableTriggers?.map((e, i) => (
                        e.name.startsWith("Drop") && (
                            <button key={i} className="button is-outlined is-link mr-2 mb-2" onClick={() => sendMission(e.name)}>
                                {(context.orderStatus && e.name === context.missionName) &&
                                    <FontAwesomeIcon icon={faCog} className="fas fa-pulse" />
                                }
                                {e.name + " "}
                            </button>
                        )
                    ))}

                    <ShowMessage />
                </section>
            </div>
        </div>
    )
}